import React, { JSX } from 'react';

const SimpleHeaderText = ({ headerText }: { headerText: string }): JSX.Element => {
  return <div>{headerText}</div>;
};

export default SimpleHeaderText;
